/**
 * Console Override for Production Builds
 *
 * This module overrides console methods (log, warn, info, debug) in production
 * to prevent console output in deployed code. console.error is preserved for
 * critical error logging in production.
 *
 * This should be imported as early as possible in the application entry point
 * to ensure all console calls are intercepted.
 *
 * Uses import.meta.env.PROD (Vite's production flag) which is available at build time
 * and doesn't require the environment config module to be loaded first.
 */

/**
 * Override console methods in production builds
 * This runs immediately when the module is imported
 *
 * Uses import.meta.env.PROD which is set by Vite during production builds
 */
if (import.meta.env.PROD) {
  // Store original console methods (for potential future use or debugging)
  const originalConsole = {
    log: console.log,
    warn: console.warn,
    info: console.info,
    debug: console.debug
    // Keep console.error available for production debugging
    // error: console.error - not overriding
  };

  // Override console methods with no-op functions
  console.log = function () {
    // No-op in production
  };

  console.warn = function () {
    // No-op in production
  };

  console.info = function () {
    // No-op in production
  };

  console.debug = function () {
    // No-op in production
  };

  // Note: console.error is intentionally NOT overridden
  // to allow critical error logging in production
}
